import Nav from "../assets/Site_Details/Primary/nav";
import siteInfo from "../assets/Site_Details/Primary/siteInfo";
import ProfileDropdown from "./ProfileDropdown";
import { FaAngleDown } from "react-icons/fa";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { RxCross2 } from "react-icons/rx";
import { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";

export default function Header({ size }) {
  const [openSubmenu, setOpenSubmenu] = useState(null);
  const [slidebar, setSlidebar] = useState(false);
  const params = useParams();
  const arrowRefs = useRef({});
  const [last3] = useState(
    params.email ? { x: -1, y: undefined } : { x: -3, y: -1 }
  );

  useEffect(() => {
    Object.entries(arrowRefs.current).forEach(([key, el]) => {
      if (el) {
        el.classList.toggle("rotate-180", openSubmenu === Number(key));
      }
    });
  }, [openSubmenu]);

  const navItems = Nav(params.email).slice(0, -3);
  const navEnd = Nav(params.email).slice(last3.x, last3.y);

  return size.width > 950 ? (
    <header className="sticky top-0 bg-white flex flex-nowrap gap-4 py-2 px-4 items-center shadow-[0.1rem_0.1rem_0.2rem_0.1rem_gray] whitespace-nowrap z-10">
      <Link
        to={params.email ? `/${params.email}/home` : "/"}
        reloadDocument
        className="flex gap-2 items-center"
      >
        <img
          src={siteInfo().logo}
          alt="site_logo"
          className="w-14 aspect-square"
        />
        <strong className="font-times text-2xl tracking-wider ">
          {siteInfo().site_name}
        </strong>
      </Link>
      <input
        type="search"
        name="search"
        id="search"
        className="p-2 rounded-2xl border-2 border-black grow"
        placeholder="Search Converters (e.g. PDF to DOCX)"
      />
      <article className="flex gap-4 items-center">
        {navItems.map((item, index) => (
          <div
            key={`navbar/firsthalf/item/${index}`}
            className="relative flex flex-col gap-2"
          >
            <div className="flex items-center gap-2">
              <Link to={params.email ? item.path : "/signin"}>{item.name}</Link>
              {item.submenu && (
                <FaAngleDown
                  ref={(el) => { arrowRefs.current[index] = el; }}
                  className="transition-all cursor-pointer"
                  onMouseEnter={() => setOpenSubmenu(index)}
                />
              )}
            </div>
            {item.submenu && (
              <div
                className={`absolute right-0 bg-white ${
                  openSubmenu === index ? "flex" : "hidden"
                } flex-wrap items-center p-4 rounded-lg gap-4 w-[500px] mt-14 border-2 box-border shrink animate-[visibleIn_1s_ease] border-black whitespace-normal`}
                onMouseLeave={() => setOpenSubmenu(null)}
              >
                {item.submenu.map((inthere, subIndex) => (
                  <Link
                    to={params.email ? inthere.path : "/signin"}
                    key={`navbar/firsthalf/item/${item.name}/sub/${subIndex}`}
                    className="flex flex-col justify-between p-2 gap-2 items-center w-24 aspect-square text-center"
                  >
                    <inthere.icon className="text-4xl text-primary" />
                    <p>{inthere.name}</p>
                  </Link>
                ))}
              </div>
            )}
          </div>
        ))}
      </article>
      <div className="min-h-full border-r-2 border-black">
        <p className="text-white">.</p>
      </div>
      <article className="flex gap-4 items-center">
        {params.email ? (
          <ProfileDropdown size={size} />
        ) : (
          navEnd.map((item, index) => (
            <Link
              key={`navbar/secondhalf/item/${index}`}
              to={item.path}
              className="bg-primary px-4 py-2 rounded-md text-white"
            >
              {item.name}
            </Link>
          ))
        )}
      </article>
    </header>
  ) : (
    <header className="sticky top-0 bg-white flex flex-nowrap gap-4 py-2 px-4 items-center shadow-[0.1rem_0.1rem_0.2rem_0.1rem_gray] whitespace-nowrap justify-between z-10">
      <Link
        to={params.email ? `/${params.email}/home` : "/"}
        reloadDocument
        className="flex gap-2 items-center"
      >
        <img
          src={siteInfo().logo}
          alt="site_logo"
          className="w-14 aspect-square"
        />
        <strong className="font-times text-2xl tracking-wider ">
          {siteInfo().site_name}
        </strong>
      </Link>
      <article className="relative flex flex-col">
        {!slidebar ? (
          <HiOutlineMenuAlt3
            className="text-5xl font-extrabold cursor-pointer transition-all"
            onMouseEnter={() => setSlidebar(true)}
          />
        ) : (
          <RxCross2
            className="text-5xl text-red-600 cursor-pointer transition-all"
            onClick={() => setSlidebar(false)}
          />
        )}
        {slidebar && (
          <article
            className="fixed top-0 right-0 flex flex-col gap-8 mt-[72px] py-4 px-8 h-screen overflow-y-scroll noscrollbar bg-white z-10 shadow-[-0.2rem_0_0_0_#a0a0a0] transition-all animate-[fromRight_1s_ease]"
            onMouseLeave={() => { setSlidebar(false); }}
          >
            {navItems.map((item, index) => (
              <div
                key={`SlideMenuItem/item/${index}`}
                className="flex flex-col gap-4"
              >
                <div className="flex gap-4 items-center">
                  <item.icon className="text-2xl text-primary" />
                  <Link to={params.email ? item.path : "/signin"} className="grow">
                    {item.name}
                  </Link>
                  {item.submenu && (
                    <FaAngleDown
                      ref={(el) => { arrowRefs.current[index] = el; }}
                      className="cursor-pointer transition-all"
                      onClick={() => {
                        setOpenSubmenu(openSubmenu === index ? null : index);
                      }}
                    />
                  )}
                </div>
                {item.submenu && (
                  <article
                    className={`${
                      openSubmenu === index ? "flex" : "hidden"
                    } flex-col gap-4 ml-8`}
                  >
                    {item.submenu.map((inthere, subIndex) => (
                      <Link
                        to={params.email ? inthere.path : "/signin"}
                        key={`SlideMenuItem/item/${item.name}/sub/${subIndex}`}
                        className="flex gap-2 items-center"
                      >
                        <inthere.icon className="text-xl text-primary" />
                        <p className="grow">{inthere.name}</p>
                      </Link>
                    ))}
                  </article>
                )}
              </div>
            ))}
            {params.email ? (
              <div className="flex gap-4 items-center px-8">
                <ProfileDropdown size={size} />
              </div>
            ) : (
              navEnd.map((item, index) => (
                <div
                  key={`SlideMenuItem/navEnd/${index}`}
                  className="flex flex-col gap-4"
                >
                  <div className="flex gap-4 items-center">
                    <item.icon className="text-2xl text-primary" />
                    <Link to={item.path} className="grow">
                      {item.name}
                    </Link>
                  </div>
                </div>
              ))
            )}
          </article>
        )}
      </article>
    </header>
  );
}